import React from "react";
import { Image as CoreImage, ImageProps as CoreImageProps } from "@hex-insights/core";
import { settings } from "@hex-insights/forms";
import { Reforge } from "@hex-insights/uploads";
import { getReforgeImageURL } from "../../Utilities";

export type ImageProps = Omit<CoreImageProps, "src"> & {
	fileKey: string;
	contentType: string;
	edits?: Reforge.ImageOptions["edits"];
};

export function Image({ fileKey, contentType, edits, onError, ...props }: ImageProps) {
	let usingReforgeURL = false;
	let src = fileKey ? settings.uploads.fileInfoToURL(fileKey, contentType) : undefined;
	const [hasReforgeError, setHasReforgeError] = React.useState(false);
	if (fileKey && edits && !hasReforgeError) {
		src = getReforgeImageURL(fileKey, edits);
		usingReforgeURL = true;
	}
	const fullOnError = React.useCallback(
		(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
			if (usingReforgeURL) {
				setHasReforgeError(true);
				return;
			}
			onError?.(event);
		},
		[usingReforgeURL, onError],
	);

	return <CoreImage src={src} onError={fullOnError} {...props} />;
}
